import { createTooltipTokens } from '../tokens/components.js';
import { type SemanticTokens, SEMANTIC } from '../tokens/semantic.js';

/**
 * Tooltip Component Configuration
 */
export function createTooltip(s: SemanticTokens) {
  const tooltipTokens = createTooltipTokens(s);
  return {
      root: {
        maxWidth: tooltipTokens.base.maxWidth,
        gutter: tooltipTokens.base.gutter,
        shadow: tooltipTokens.base.shadow,
        padding: `${tooltipTokens.base.paddingY} ${tooltipTokens.base.paddingX}`,
        borderRadius: tooltipTokens.base.radius,
      },
      colorScheme: {
        light: {
          root: {
            background: tooltipTokens.bgDefault,
            color: tooltipTokens.fgDefault,
          },
        },
      },
      };
}
export const tooltip = createTooltip(SEMANTIC);